import { lazy } from "react";
import { enumPermisosDavivienda } from "./enumPermisosDavivienda";
/** Componente de iconos */
const AppIcons = lazy(() => import("../../../components/Base/AppIcons"));

/**
 * RecaudoEmpresarialDavivienda
 */
const RecaudoEmpresarialDavivienda = lazy(() =>
  import("./RecaudoEmpresarialDavivienda")
);
const CargarArchivos = lazy(() =>
  import("./views/CargarArchivosRecaudo/CargarArchivos")
);
const HistoricoContingencia = lazy(() =>
  import("./views/HistoricoContingenciaRecaudo/HistoricoContingencia")
);
const TransaccionesRecaudo = lazy(() =>
  import("./views/TransaccionesRecaudo/Transacciones")
);


const listPermissions = Object.values(enumPermisosDavivienda);

export const listPermissionsDavivienda = listPermissions.splice(
  listPermissions.length / 2
);

const rutasDaviviendaRecaudoEmpresarial = {
  //RecaudoEmpresarialDavivienda
  link: "/recaudoEmpresarial/recaudoEmpresarialDavivienda",
  label: (
    <AppIcons
      Logo={"RECAUDO"}
      name="Recaudo Empresarial Davivienda"
    />
  ),
  component: RecaudoEmpresarialDavivienda,
  permission: listPermissionsDavivienda,
  subRoutes: [
    {
      link: "/recaudoEmpresarial/recaudoEmpresarialDavivienda/CargarArchivos",
      label: <AppIcons Logo={"RECAUDO"} name="Cargar Archivos" />,
      component: CargarArchivos,
      permission: [enumPermisosDavivienda.Recaudo_empresarial_PDP],
    },
    {
      link: "/recaudoEmpresarial/recaudoEmpresarialDavivienda/HistoricoContingencia",
      label: (
        <AppIcons Logo={"RECAUDO"} name="Histórico Contingencia" />
      ),
      component: HistoricoContingencia,
      permission: [enumPermisosDavivienda.Recaudo_empresarial_contingencia_PDP],
    },
    {
      link: "/recaudoEmpresarial/recaudoEmpresarialDavivienda/TransaccionesRecaudo",
      label: (
        <AppIcons Logo={"RECAUDO"} name="Transacciones Recaudo" />
      ),
      component: TransaccionesRecaudo,
      permission: [enumPermisosDavivienda.Recaudo_empresarial_transacciones_PDP],
    },
  ],
};

export default rutasDaviviendaRecaudoEmpresarial;
